import { ConfigProvider } from 'antd';
var MergedConfigConsumer = ConfigProvider.ConfigContext.Consumer;
export default MergedConfigConsumer;